import {Service} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {IsVehicleConfigurableValueObject} from '../ValueObjects/IsVehicleConfigurableValueObject.js'
import {VehiclesServicesFactory} from './factory.js'

export class GetIsVehicleConfigurableVehiclesService extends Service {
  #service
  #config

  constructor({service, config}) {
    super()
    this.#service = service
    this.#config = config
  }

  static create({config}) {
    return new GetIsVehicleConfigurableVehiclesService({
      service: VehiclesServicesFactory.getSpecsVehicleService({config}),
      config
    })
  }

  async execute({makeId}) {
    try {
      if (!makeId) throw InvalidParamsSharedError.create('makeId is required')
      const {VEHICLE_SPECS_CONTEXT} = this.#config.get('vehicles')
      const {CATEGORY2_ID_CAR} = this.#config.get('search')

      const [error, response] = await this.#service.execute({
        nextField: VEHICLE_SPECS_CONTEXT.HIRED_MAKES,
        params: {
          section1Id: CATEGORY2_ID_CAR,
          onlyInCommercialization: true
        }
      })

      if (error) throw error

      const {items} = response.toJSON()

      return IsVehicleConfigurableValueObject.createFromMakes({
        makeId,
        makesList: items
      })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
